import React, {Component} from 'react';
import {Dropdown, Divider} from 'semantic-ui-react';
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'



// const SeeResultsTab = () => <div> see results goes here. </div>

class PollCardCompleted extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dropDownClicked: false,
            size: 0,
            id: ""

        }
    }

    changeDropDown = () =>{
        this.setState({dropDownClicked: !this.state.dropDownClicked})
    }
    async componentDidMount(){
        this.setState({state: this.props.item.teams})
        let id=this.state.id
        const accessToken = localStorage.getItem("accessToken");
        const teamDet = await axios.post('http://localhost:8080/fetch-teams',{},{headers:{ Authorization: `Bearer ${accessToken}` }})
        console.log("total teams = ", teamDet)

        const teamArr = teamDet.data.data
        var lenMem = 0
        for( var item of teamDet.data.data){
            lenMem+=item.size
        }
        const size = teamArr.filter(i=> id.includes(i._id))
        console.log("filtered teams = ", size)
        let len = 0
        for(let a of size){
            // console.log("a = ,", a)
            len+=a.size
        }
        console.log("filtered len = ", len)
        this.setState({size: lenMem})
        

    }
    render() {
        
        console.log("inside graph props = ",this.props.item)
        // return <div>test</div>

        const choice = []
        var total = 0
        var indexMax = 0
        var max = 0
        var count =0
        if(this.props.item == undefined) return null;
        var totalV = this.props.item.users.length
        console.log("% calcu = ", totalV, " === ", this.state.size)
        for(const i of this.props.item.choices){
            
         total =total + i.totalVotes
         if(i.totalVotes>max) {
             max=i.totalVotes
             indexMax=count
        }
        count=count+1

        }
        count = 0 
        console.log("total Votes = ", total)
        let size = 0
        //remove arrow func
        
        // if(this.props.item.pollType==="ENPS"){this.getTeamDetails()}
        console.log("size = ", this.state.size)
        for(const i of this.props.item.choices){
            const perc = total === 0 ? 0 : (i.totalVotes/total)*100
            const wid = perc === 0 ? 100 : perc 
            choice.push(
            <div className="choiceBar">
                <div className="choiceBarInside" style={(count===indexMax)?{backgroundColor: "rgba(0, 145, 255, 0.19)", width: wid+"%"}:{backgroundColor: "rgba(95, 95, 95, 0.36)", width: wid+"%"}}>
                    <div>{i.description}</div>
                    <div>{perc+"%"}</div>
                </div>
            </div>
            ) 
            count=count+1
        }
        if(this.state.dropDownClicked && this.props.item.question!=undefined){ 
            return (

                <div className="pollContainer" style={this.props.item.pollType === "ENPS" ? {height: "500px"}: {}}>
                    <div className="dropDown" onClick={()=>{this.changeDropDown()}}><FontAwesomeIcon icon={faChevronDown} style={{color: "grey"}} /></div>
                    <div className="question"> {this.props.item.question}</div>
                    <div className="pollChoices">
                        {choice}
                    </div>
                    <div className="pollLikes"><FontAwesomeIcon icon={faThumbsUp} style={{color: "grey"}} /> {this.props.item.totalLikes} </div>
        
        
                </div>
            )
        }
        else{
            if(this.props.item.question!=undefined){
            return (

                <div className="pollContainer" style={{height: "100px"}}>
                    <div className="dropDown" onClick={()=>{this.changeDropDown()}}><FontAwesomeIcon icon={faChevronDown} style={{color: "grey"}} /></div>
                    <div className="question"> {this.props.item.question}</div>
                    <div className="pollLikes">  <FontAwesomeIcon icon={faThumbsUp} style={{color: "grey"}} />{'\u00A0'}{'\u00A0'}{'\u00A0'}{this.props.item.totalLikes}</div>
                <div className="pollLikes" style={this.props.item.pollType === "ENPS" ? {display: "block"}: {display: "block"}}> {'\u00A0'}{'\u00A0'}{'\u00A0'}% completion: {((total/this.state.size)*100).toFixed(2)}</div>
                    
        
        
                </div>
            )

        }}
    }
}
export default PollCardCompleted;